<h1 class="page-header pt-5">Sorry, this page isn't available</h1>
<p class="text-center p-5">The link you followed may be broken, or the page may have been removed.</p>
<p class="text-center p-5">
  <a class="text-center p-5 cursor-pointer go-back" (click)="goBack()">
    <mat-icon class="mr-2 pt-1">arrow_back</mat-icon>Go back to the previous page
  </a>
</p>
